import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "purchase-invoice-container" }
const _hoisted_2 = {
  key: 0,
  class: "debug-toolbar",
  "aria-label": "External App SDK debug controls"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "error-alert",
  role: "alert"
}
const _hoisted_5 = { class: "error-message" }
const _hoisted_6 = {
  key: 3,
  class: "success-alert",
  role: "status"
}
const _hoisted_7 = { class: "success-message" }
const _hoisted_8 = {
  key: 5,
  class: "submitting-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceDetails = _resolveComponent("InvoiceDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showDebugTools)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "debug-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.maximizeIframe && _ctx.maximizeIframe(...args)))
          }, "Maximize"),
          _createElementVNode("button", {
            class: "debug-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tryMinimize && _ctx.tryMinimize(...args)))
          }, "Minimize"),
          _createElementVNode("button", {
            class: "debug-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.tryClose && _ctx.tryClose(...args)))
          }, "Close")
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("p", null, "Loading page...", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "error-icon" }, "⚠️", -1)),
          _createElementVNode("span", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Error:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
          ]),
          _createElementVNode("button", {
            class: "error-close",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearError && _ctx.clearError(...args))),
            "aria-label": "Close error message"
          }, "✖")
        ]))
      : _createCommentVNode("", true),
    (_ctx.successMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "success-icon" }, "✅", -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.successMessage), 1)
        ]))
      : (_ctx.invoice)
        ? (_openBlock(), _createBlock(_component_InvoiceDetails, {
            key: 4,
            invoice: _ctx.invoice,
            accounts: _ctx.accounts,
            dimensions: _ctx.dimensions,
            vatCodes: _ctx.vatCodes,
            users: _ctx.users,
            onApprove: _ctx.approve,
            onReject: _ctx.reject,
            onUpdate: _ctx.update,
            onUpdateInvoice: _ctx.handleInvoiceUpdate,
            onReassign: _ctx.reassign
          }, null, 8, ["invoice", "accounts", "dimensions", "vatCodes", "users", "onApprove", "onReject", "onUpdate", "onUpdateInvoice", "onReassign"]))
        : _createCommentVNode("", true),
    (_ctx.submitting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "submitting-overlay-content" }, [
            _createElementVNode("span", { class: "spinner" }),
            _createElementVNode("span", null, "Processing...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}